// extracted by mini-css-extract-plugin
module.exports = {"rolePage":"role_rolePage__2oGfj","delBtn":"role_delBtn__2K5Px","userLabel":"role_userLabel__3xaAA","disabled":"role_disabled__22bCX"};